import { useGo, useNavigation } from "@refinedev/core";
import { useEffect } from "react";

// workaround to support breadcrumb link to first item
export const MediaIndexPage = () => {
  // const { list } = useNavigation();
  const go = useGo();
  // useEffect(() => {
  //   if (list) list("media_projects");
  // }, [list]);
  useEffect(() => {
    go?.({ to: "/home" });
  }, [go]);

  return null;
};
